
import { Component,OnInit, ElementRef, ViewChild, Renderer2, HostListener, AfterViewInit, Inject, inject, Injector, afterNextRender  } from '@angular/core';
import * as AOS from 'aos';
import Swiper from 'swiper'; 
import { Title, Meta } from '@angular/platform-browser';
import { bounce, flash, pulse, rubberBand } from 'ng-animate';
import { trigger, transition, useAnimation } from '@angular/animations';
import { OwlOptions } from 'ngx-owl-carousel-o';
declare var $: any; 
import {DOCUMENT,  isPlatformBrowser } from '@angular/common';
import {  PLATFORM_ID } from '@angular/core';
import { Constants } from '../constants';
import { SeoService } from '../seo.service';
import { constants } from 'node:buffer';
 declare var particlesJS: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  animations: [
    trigger('bounce', [
      transition('* => *', useAnimation(bounce))
    ])
  ]
})
export class HomeComponent implements OnInit, AfterViewInit{

pageTitle="Technology Consulting Services & Solutions | Maganti IT";
pageDescription="Explore insights and inspiration to unlock innovation, build trust, and engineer advantage for your digital journey!";
pageImage=Constants.webURL+"/assets/images/homepage/technology-cap/artifical-intellegence.jpg";
pageUrl=Constants.webURL;
@ViewChild('carousel', { static: false }) carousel!: ElementRef;
isBrowser:boolean=false;
  isVisible = true;
  baseUrl=Constants.baseUrl;

  toggleVisibility() {
    this.isVisible = !this.isVisible;
  }
  customOptions: OwlOptions = {
    loop: true,
    margin: 10,
    nav: true,
    dots: true,
    responsive: {
      0: {         // for mobile screens
        items: 1,
        margin: 5
      },
      600: {       // for tablets
        items: 2,
        margin: 10
      },
      1000: {      // for desktops
        items: 3,
        margin: 15
      }
    }
  };


  slides = [
    { imageUrl: '../../../assets/images/homepage/cube/cube-1.png', altText: 'Image 1' },
    { imageUrl: '../../../assets/images/homepage/cube/cube-2.png', altText: 'Image 2' },
    { imageUrl: '../../../assets/images/homepage/cube/new-cubeimage.png', altText: 'Image 3' }
  ];

 
  
  constructor(private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document, @Inject(PLATFORM_ID) private platformId: Object,private elementRef: ElementRef,private title: Title, private meta: Meta,private seoService:SeoService,
   ) { 
      this.isBrowser=isPlatformBrowser(this.platformId);
    }

 
     brandLogoSlider = {
      slidesToShow: 6,
      slidesToScroll: 1,
      loop: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 7000,
      speed: 7000,
      breakpoints: {
          1499: {
              slidesPerView: 6
          },

          991: {
              slidesPerView: 4
          },

          767: {
              slidesPerView: 3

          },

          575: {
              slidesPerView: 2
          }
      }
  };

  ngOnInit() {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Maganti IT Resources, LLC",
  "image": "https://mitresource.com/assets/images/homepage/update-mitimage.png",
  "@id": "",
  "url": "https://mitresource.com/",
  "telephone": "1-855-217-4637",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "21 State St, Waterbury, CT 06702",
    "addressLocality": "Connecticut",
    "addressRegion": "CT",
    "postalCode": "CT 06702",
    "addressCountry": "US"
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday"
    ],
    "opens": "09:00",
    "closes": "18:00"
  },
  "sameAs": [
    "https://www.linkedin.com/company/maganti-it-resources-llc/mycompany/",
    "https://www.instagram.com/magantiit/",
    "https://twitter.com/mitresource"
  ]} `;
   
    this._renderer2.appendChild(this._document.head, script);
    this.seoService.createLinkForCanonicalURL();
    this.setTitleAndMetaTags();
    if (this.isBrowser) {
     
     particlesJS.load('particles-js', 'assets/particles.json', null);
     AOS.init({startEvent: 'load'});
  $(window).on('load', function() {AOS.refresh();});
    
   
    }
  }

  @HostListener('mouseover')
  onmouseover() {
    const items: NodeListOf<HTMLElement> = this.elementRef.nativeElement.querySelectorAll('.item');
    items.forEach(item => item.classList.remove('active'));
    this.elementRef.nativeElement.classList.toggle('active');
   
  }
  ngAfterViewInit(){
    if (this.isBrowser) {

      this.initializeSlickCarousel();
    //   $('.owl-carousel').owlCarousel({
    //     loop: true,         
    //     margin: 10,         
    //     pagination:false,
    //     dots:false,
    //     responsive:{
    //       0:{
    //         items:1,
    //         margin: 20,
    //       },
    //       600:{
    //         items:3,
    //         margin: 15,
    //       },
    //       1000:{
    //         items:4,
    //         margin: 15,
    //       }
    //     }
    // });
    $(".custom-carousel").owlCarousel({
      center: false,
      dots: false,
      items: 2,
      startPosition: 0,
      margin: 0,
      smartSpeed: 450,
      onInitialized: (event:any) => {
        this.addAccessibilityToDots(event);
      },
      responsive: {
          0: {
              items: 1, // Single item on mobile view
              margin: 5,
              center:true,
              dots:true
          },
       
          1000: {
              items: 6, // Three items on desktop
              // margin: 5,
              dots:true,
             
          },
          // 1200: {
          //     items: 4, // Four items on large screens
          //     margin: 25,
          // }
      }
  });
    const items = this.elementRef.nativeElement.querySelectorAll('.owl-carousel .item');

      items.forEach((item: HTMLElement) => {
        this._renderer2.listen(item, 'mouseenter', () => {
          items.forEach((el: HTMLElement) => {
            if (el !== item) {
              this._renderer2.removeClass(el, 'active');
            }
          });
          if (item.classList.contains('active')) {
            this._renderer2.removeClass(item, 'active');
          } else {
            this._renderer2.addClass(item, 'active');
          }
        });
      });
AOS.init({
    duration: 500
});



    }
    this.addAriaLabelsToDots();
  }
  private addAriaLabelsToDots(): void {
    setTimeout(() => {
      const dots = this.carousel.nativeElement.querySelectorAll('.owl-dot');
      dots.forEach((dot: HTMLElement, index: number) => {
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      });
    }, 500); // Timeout ensures dots are available after Owl Carousel initialization
  }
  private setTitleAndMetaTags(): void {
    // Set page title
    this.title.setTitle(this.pageTitle);

    // Set meta tags
    this.meta.updateTag({ name: 'description', content: this.pageDescription });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:title', content: this.pageTitle });
    this.meta.updateTag({ property: 'og:url', content: this.pageUrl });
    this.meta.updateTag({ property: 'og:image', content: this.pageImage });
    this.meta.updateTag({ property: 'og:description', content: this.pageDescription });
  }
  initializeSlickCarousel() {
    $('.spotlight_carousel').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
  addAccessibilityToDots(event: any) {
    const totalSlides = event.item.count; 
    $('.owl-dot').each((index:any, dot:any) => {
      const slideNumber = index + 1; 
      const ariaLabel = `Go to slide ${slideNumber}`;
      $(dot).attr('aria-label', ariaLabel);
      $(dot).append(`<span class="sr-only">Slide ${slideNumber}</span>`);
    });
    $('.owl-dot.active').each((index:any, activeDot:any) => {
      $(activeDot).attr('aria-label', `Current slide, slide ${index + 1}`);
      $(activeDot).find('.sr-only').text(`Slide ${index + 1} (active)`);
    });
  }
  swiperBreakpoints = {
    320: { slidesPerView: 2 },      
    768: { slidesPerView: 4 },      
    1024: { slidesPerView: 6 }      
  };

}
